// src/features/auth/useAuthorStatus.ts
import { useIsAdmin } from './useIsAdmin'
import { useIsAuthor } from './useIsAuthor'
import { useMe } from './useMe'

/**
 * Статус автора для бейджа: «проверенный» — админ или автор с правом публиковать
 * в каталог (`canPublish`), остальные авторы — бета. Один источник для шапки
 * профиля и меню в сайдбаре, чтобы два места не разошлись.
 */
export const useAuthorStatus = () => {
  const { data } = useMe()
  const { isAuthor } = useIsAuthor()
  const { isAdmin } = useIsAdmin()
  const isVerified = isAdmin || (isAuthor && (data?.canPublish ?? false))
  return { isAuthor, isVerified }
}
